import { ButtonHTMLAttributes } from "react";
import { Button, ButtonProps } from "../button";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
  variant?: ButtonProps<"icon">["variant"];
  title: string;
}

export const IconButton = ({ title, variant, type, ...props }: Props): JSX.Element => {
  return (
    <Button
      {...props}
      title={title}
      type={type ?? "button"}
      size="icon"
      variant={variant ?? "ghost"}
    >
      {props.children}
    </Button>
  );
};
